<!-- Tab bar -->
<div class="doc-tab-bar">
  <button
    *ngFor="let tab of tabs; let i = index"
    class="doc-tab"
    [class.doc-tab-active]="selectedTab === i"
    (click)="selectedTab = i">
    {{ tab.title }}
  </button>
</div>

<!-- Main Storage -->
<div *ngIf="selectedTab === 0" class="doc-tab-content">
  <div class="form-style column gpd-scroll" [style]="'height:fit-content;'">
    <div class="document-top-bar">
      <dx-text-box class="document-search-input" (onKeyUp)="handleDocumentSearch($event)" [(value)]="searchTerm"
        [showClearButton]="true" i18n-placeholder="@@finaleAblageSearch" width="300px" height="36px"
        placeholder="Search documents..." valueChangeEvent="keyup" (onValueChanged)="handleDocumentSearch(null)"
        [mode]="'search'" style="border-radius: 8px; border-color: var(--color-grey-300);">
      </dx-text-box>
    </div>

    <dx-file-manager *ngIf="filesLoaded" [currentPath]="preselectedFolder" id="fileManager" #docView
      [fileSystemProvider]="files" nameExpr="foldername" itemsExpr="subFolders"
      [customizeThumbnail]="customizeThumbnail"
      selectionMode="none"
      (onSelectedFileOpened)="openFile($event)" height="80%" (onContextMenuItemClick)="onContextMenuShowing($event)"
      icon="file" [currentPath]="preselectedFolder" [customizeDetailColumns]="fileManager_customizeDetailColumns"
      (onContextMenuShowing)="handleContextMenuShowing($event)" (onItemDownloading)="handleDownloading($event)"
      (onErrorOccurred)="handleErrorOccurred($event)" [rootFolderName]="translateItems.files">
      <div *dxTemplate="let cell of 'externallyModifiedCell'">
        <span #extModRef class="external-mod-warning"
          *ngIf="cell?.data && !cell.data.isDirectory && cell.data.dataItem?.externallyModified">
          <app-svg-icon icon="alert" [size]="18" color="var(--warning-color)"></app-svg-icon>
          <dx-tooltip [target]="extModRef" showEvent="mouseenter" hideEvent="mouseleave" position="top">
            <div *dxTemplate="let d of 'content'" i18n="@@fileModifiedExternally">Document was edited outside the system in SharePoint. Please check in SharePoint.</div>
          </dx-tooltip>
        </span>
      </div>
      <dxo-toolbar>
        <dxi-item name="download" icon="assets/icons/download.svg"></dxi-item>
        <dxi-item name="refresh" [text]="translateItems.refresh"></dxi-item>
        <dxi-item name="switchView" [text]="translateItems.detailedView" icon="view"></dxi-item>
      </dxo-toolbar>
      <dxo-notifications [showPanel]="false" [showPopup]="false"></dxo-notifications>
      <dxo-permissions [download]="true" [create]="false" [copy]="false" [move]="false" [delete]="false"
        [rename]="false" [upload]="false">
      </dxo-permissions>
    </dx-file-manager>

    <div>
      <dx-load-panel [visible]="!filesLoaded"></dx-load-panel>
    </div>
  </div>
</div>

<!-- Sandbox -->
<div *ngIf="tabs[1] && selectedTab === 1" class="doc-tab-content">
  <div class="sandbox-info-message" *ngIf="sandboxStatusLoaded && sandboxError">
    <p>{{ sandboxError }}</p>
  </div>

  <div *ngIf="!sandboxStatusLoaded">
    <dx-load-panel [visible]="true"></dx-load-panel>
  </div>

  <div *ngIf="sandboxStatusLoaded && sandboxLinkConfigured && !sandboxFolderLinked && !sandboxError" class="sandbox-folder-picker">
    <p i18n="@@sandboxSelectFolderLabel">Select a sandbox folder for this site:</p>
    <div class="sandbox-folder-picker-row">
      <dx-select-box
        [dataSource]="rootFolders"
        displayExpr="name"
        valueExpr="itemId"
        [(value)]="selectedFolderItemId"
        [placeholder]="translateItems.selectFolder"
        [searchEnabled]="true"
        searchExpr="name"
        width="300px">
      </dx-select-box>
      <app-gpd-button
        type="primary"
        i18n-text="@@linkFolder"
        text="Link Folder"
        [disabled]="!selectedFolderItemId || linkingFolder"
        (onClick)="linkSandboxFolder()">
      </app-gpd-button>
    </div>
    <div *ngIf="!rootFoldersLoaded">
      <dx-load-panel [visible]="true"></dx-load-panel>
    </div>
  </div>

  <div class="form-style column gpd-scroll sandbox-dropzone" *ngIf="sandboxStatusLoaded && sandboxLinkConfigured && sandboxFolderLinked && !sandboxError" [style]="'height:fit-content;'"
    (dragover)="onSandboxDragOver($event)" (drop)="onSandboxDrop($event)">
    <div class="sandbox-top-bar">
      <dx-text-box class="document-search-input" (onKeyUp)="handleSandboxSearch($event)" [(value)]="sandboxSearchTerm"
        [showClearButton]="true" i18n-placeholder="@@sandboxSearch" width="300px" height="36px"
        placeholder="Search sandbox..." valueChangeEvent="keyup" (onValueChanged)="handleSandboxSearch(null)"
        [mode]="'search'" style="border-radius: 8px; border-color: var(--color-grey-300);">
      </dx-text-box>
      <div class="sandbox-folder-actions">
        <app-gpd-button
          *ngIf="sandboxRootFolderUrl"
          type="text"
          icon="arrow-right"
          i18n-text="@@openInSharePoint"
          text="Open in SharePoint"
          (onClick)="openInSharePoint(sandboxRootFolderUrl)">
        </app-gpd-button>
        <app-gpd-button
          *ngIf="isAdmin"
          type="danger-outline"
          i18n-text="@@disconnectSandboxFolder"
          text="Verknüpfung trennen"
          (onClick)="disconnectPopupVisible = true">
        </app-gpd-button>
      </div>
    </div>

    <dx-file-manager
      *ngIf="sandboxFilesLoaded"
      #sandboxView
      id="sandboxFileManager"
      [fileSystemProvider]="sandboxFiles"
      [customizeThumbnail]="customizeThumbnail"
      [customizeDetailColumns]="fileManager_customizeDetailColumns"
      nameExpr="name"
      isDirectoryExpr="isDirectory"
      itemsExpr="items"
      (onSelectedFileOpened)="openSandboxFile($event)"
      (onCurrentDirectoryChanged)="onSandboxDirectoryChanged($event)"
      (onItemDeleting)="onSandboxItemDeleting($event)"
      (onItemRenaming)="onSandboxItemRenaming($event)"
      (onItemMoving)="onSandboxItemMoving($event)"
      height="80%">
      <div *dxTemplate="let cell of 'externallyModifiedCell'">
        <span #extModRefSb class="external-mod-warning"
          *ngIf="cell?.data && !cell.data.isDirectory && cell.data.dataItem?.externallyModified">
          <app-svg-icon icon="alert" [size]="18" color="var(--warning-color)"></app-svg-icon>
          <dx-tooltip [target]="extModRefSb" showEvent="mouseenter" hideEvent="mouseleave" position="top">
            <div *dxTemplate="let d of 'content'" i18n="@@fileModifiedExternally">Document was edited outside the system in SharePoint. Please check in SharePoint.</div>
          </dx-tooltip>
        </span>
      </div>
      <dxo-toolbar>
        <dxi-item name="refresh"></dxi-item>
        <dxi-item name="switchView"></dxi-item>
        <dxi-item location="before" template="newFolderBtn" [visible]="canEditSandbox"></dxi-item>
        <dxi-item location="before" template="uploadBtn" [visible]="canEditSandbox"></dxi-item>
      </dxo-toolbar>
      <div *dxTemplate="let _ of 'newFolderBtn'">
        <app-gpd-button type="text" icon="add" i18n-text="@@newDirectory" text="New Directory" (onClick)="openNewFolderDialog()"></app-gpd-button>
      </div>
      <div *dxTemplate="let _ of 'uploadBtn'">
        <app-gpd-button type="text" icon="upload" i18n-text="@@uploadFiles" text="Upload Files" (onClick)="triggerSandboxFileInput()"></app-gpd-button>
      </div>
      <dxo-notifications [showPanel]="false" [showPopup]="false"></dxo-notifications>
      <dxo-permissions
        [create]="canEditSandbox"
        [copy]="canEditSandbox"
        [move]="canEditSandbox"
        [delete]="canEditSandbox"
        [rename]="canEditSandbox"
        [upload]="canEditSandbox"
        [download]="true">
      </dxo-permissions>
    </dx-file-manager>
    <input type="file" id="sandbox-file-input" style="display:none" multiple (change)="onSandboxFileSelected($event)">
    <dx-load-panel [visible]="sandboxUploading" [showPane]="true" message="Uploading..." i18n-message="@@uploading"></dx-load-panel>

    <app-generic-popup
      [(visible)]="newFolderPopupVisible"
      i18n-title="@@newDirectory"
      title="New Directory"
      [allowOutsideClick]="true"
      [width]="380"
      [buttons]="newFolderButtons">
      <dx-text-box
        [(value)]="newFolderName"
        placeholder="Folder name"
        i18n-placeholder="@@folderName"
        valueChangeEvent="keyup"
        (onEnterKey)="confirmCreateFolder()">
      </dx-text-box>
    </app-generic-popup>

    <app-generic-popup
      [(visible)]="disconnectPopupVisible"
      i18n-title="@@disconnectSandboxFolder"
      title="Verknüpfung trennen"
      [allowOutsideClick]="true"
      [width]="440"
      [buttons]="disconnectButtons">
      <p i18n="@@disconnectSandboxConfirmQuestion">Are you sure you want to disconnect the sandbox folder?</p>
      <p class="popup-hint" i18n="@@disconnectSandboxConfirmHint">You can always reconnect it later.</p>
    </app-generic-popup>

    <div>
      <dx-load-panel [visible]="sandboxFolderLinked && !sandboxFilesLoaded"></dx-load-panel>
    </div>
  </div>
</div>
